jQuery.browser={};
(function(){
	jQuery.browser.msie=false;
	jQuery.browser.version=0;
	if(navigator.userAgent.match(/MSIE ([0-9]+)./)){
		jQuery.browser.msie=true;
		jQuery.browser.version=RegExp.$1;
	}
})();

$( document ).ready( function() {
	/* - - - - - - - - - - - - - -       init AOS       - - - - - - - - - - - - - - - */
	setTimeout( function() {
		AOS.init({
			// startEvent: 'load',
			duration: 1000,
			offset: 30,
			once: true
		});
	}, 300 );

	/* - - - - - - - - - - - - - -       init rellax       - - - - - - - - - - - - - - - */
	var rellax = new Rellax( '.js-rellax', {
		// speed: -2,
		// center: true,
		// wrapper: null,
		// round: true,
		// vertical: true,
		// horizontal: false
	});
	// if ( $( '.js-rellax' ).length ) {
	// 	$(window).on('scroll', function() {
	// 		rellax.refresh();
	// 	});
	// }

	document.addEventListener('aos:in', ({ detail }) => {
		const $this = $( detail );
		if ( $this.find( '.js-rellax' ).length ) {
			const timeStart = $this.data( 'aos-delay' ),
				timeEnd = timeStart + 1000;
			for ( let i = timeStart; i <= timeEnd; i += 100 ) {
				setTimeout( function() {
					rellax.refresh();
				}, i );
			}
		}
	});
	document.addEventListener('aos:out', ({ detail }) => {
	//   console.log('animated out', detail);
	});

	/* - - - - - - - - - - - - - -       init certificate slider       - - - - - - - - - - - - - - - */
	function initCertSlider( $certSlider, count ) {
		$certSlider.owlCarousel({
			loop: ( count > 1 ),
			// loop: false,
			nav: false,
			dots: false,
			smartSpeed: 600,
			items: 1,
			slideBy: 1,
			margin: 8,
			responsive: {
				768: {
					loop: ( count > 2 ),
					nav: false,
					items: 2,
					margin: 20
				},
				992: {
					loop: ( count > 2 ),
					nav: false,
					items: 2,
					margin: 30
				},
				1200: {
					loop: ( count > 3 ),
					nav: false,
					items: 3,
					margin: 30
				}
			}
		});
	}
	$( '.js-cert-slider' ).each( function() {
		const $this = $( this ),
			count = $this.find( '> *' ).length;
		initCertSlider( $this, count );
	});

	/* - - - - - - - - - - - - - -       basket price width       - - - - - - - - - - - - - - - */
	function basketPrice() {
		const price = $('.modal-basket__box-price');
		var priceWidth = 0;
		price
			.removeAttr('style')
			.each(function(){
			if ($(this).width() > priceWidth) {
				priceWidth = $(this).width();
			}
		});
		price.width(priceWidth);
	}

	/* - - - - - - - - - - - - - -       init fancybox       - - - - - - - - - - - - - - - */
	$( '[data-fancybox]' ).fancybox({
		closeExisting: true,
		// protect: true,
		animationEffect: 'fade',
		// animationDuration: 600,
		touch: false,
		autoFocus:false,
		buttons: [
			// "zoom",
			//"share",
			"slideShow",
			//"fullScreen",
			//"download",
			// "thumbs",
			"close"
		],
		smallBtn: true,
		btnTpl: {
			smallBtn:
				'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
					'<span class="icon icon-i-close"></span>' +
				"</button>"
		},
		afterShow: function(instance, current) {
			basketPrice();
			current.$slide.find( '.js-select' ).select2({
				language: 'uk',
				width: '100%',
				minimumResultsForSearch: -1,
				dropdownParent: current.$content
			});
		}
	});

	/* - - - - - - - - - - - - - -       init fancybox video       - - - - - - - - - - - - - - - */
	$( '[data-fancybox-video]' ).fancybox({
		smallBtn: false,
		btnTpl: {
			smallBtn:
				'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
					'<span class="icon icon-i-close"></span>' +
				"</button>"
		},
		video: {
			tpl:
				'<video class="fancybox-video" autoplay playsinline muted loop="loop" controls controlsList="nodownload" poster="{{poster}}">' +
					'<source src="{{src}}" type="{{format}}" />' +
					'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
				'</video>',
			format: '', // custom video format
			autoStart: true
		}
	});

	/* - - - - - - - - - - - - - -       init inputmask       - - - - - - - - - - - - - - - */
	$( '[type="tel"]' ).inputmask( '+38 (999) 999 99 99' );

	/* - - - - - - - - - - - - - -       init select2       - - - - - - - - - - - - - - - */
	$( '.js-select' ).select2({
		language: 'uk',
		width: '100%',
		minimumResultsForSearch: -1,
	}).on( 'select2:select', function( e ) {
		if ( e.params.data.text === '' ) {
			$( e.target ).removeClass( 'filled' );
		} else {
			$( e.target ).addClass( 'filled' );
		}
	});
	$( '.js-select' ).each( (i, item) => {
		if ( $( item ).val() === '' ) {
			$( item ).removeClass( 'filled' );
		} else {
			$( item ).addClass( 'filled' );
		}
	});
	if ( $( '.js-select' ).val() !== '' ) {

	}

	if ($('.js-select--weight').length) {
		let selectPrice = $('.js-select--weight');
		selectPrice.each(function () {
			var weight = $(this).parents('.form-group').find('.select2-selection__rendered').text();
			var price = $(this).parents('.form-group').find('label').text();

			$(this).parents('.form-group').find('.select2-selection__rendered').text(price);
			$(this).parents('.form-group').find('label').text($(this).data('lang-weight') + ' ' + weight);
		})
	}

	/* - - - - - - - - - - - - - -       input validate       - - - - - - - - - - - - - - - */
	function setInput() {
		$( 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]):not(.login-code)' ).each( function() {
			const $parent = $( this ).closest( '.form-group' );
			if ( $( this ).val() !== '' ) {
				$parent.addClass( 'filled' );
			}
		});
	}
	setInput();
	$( 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]):not(.login-code)' ).on( 'input', function() {
		const $parent = $( this ).closest( '.form-group' );
		if ( $( this ).val() !== '' ) {
			$parent.addClass( 'filled' );
		} else {
			if ( $( this ).attr( 'type' ) !== 'tel' ) {
				$parent.removeClass( 'filled' );
			}
		}
	});
	$( '[type="tel"]' ).on( 'mouseenter focus', function() {
		const $parent = $( this ).closest( '.form-group' );
		$parent.addClass( 'filled' );
	});
	$( '[type="tel"]' ).on( 'mouseleave', function() {
		const $parent = $( this ).closest( '.form-group' );
		if ( $( this ).val() === '' && !$( this ).is( ':focus' )) {
			$parent.removeClass( 'filled' );
		}
	});
	$( '[type="tel"]' ).on( 'blur', function() {
		const $parent = $( this ).closest( '.form-group' );
		if ( $( this ).val() === '' ) {
			$parent.removeClass( 'filled' );
		}
	});
	$( 'textarea' ).on( 'input', function() {
		const $parent = $( this ).closest( '.form-group' );
		if ( $( this ).val() !== '' ) {
			$parent.addClass( 'filled' );
		} else {
			$parent.removeClass( 'filled' );
		}
		// this.setAttribute("style", "height:" + (this.scrollHeight) + "px;overflow-y:hidden;");
		this.style.height = "auto";
		this.style.height = (this.scrollHeight) + "px";
	});
	$( document ).on( 'click', '.js-field-clear', function() {
		const $parent = $( this ).closest( '.form-group' );
		$parent.removeClass( 'filled' );
		$parent.find( 'input, textarea' ).val( '' ).focus();
		if ( $( this ).closest( '.header-city' ).length ) {
			$( this ).closest( '.header-city' ).find( '.header-city__modal-list ul li' ).removeClass( 'hide' );
			$( this ).closest( '.header-city' ).find( '.search-empty' ).removeClass( 'show' );
		}
	});

	/* - - - - - - - - - - - - - -       input AirDatepicker       - - - - - - - - - - - - - - - */
	const localeUk = {
		days: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П’ятниця', 'Субота'],
		daysShort: ['Нед', 'Пнд', 'Вів', 'Срд', 'Чтв', 'Птн', 'Сбт'],
		daysMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
		months: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
		monthsShort: ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
		today: 'Сьогодні',
		clear: 'Очистити',
		dateFormat: 'dd.MM.yyyy',
		timeFormat: 'HH:mm',
		firstDay: 1
	}

	new AirDatepicker('.js-date', {
		locale: localeUk,
		onSelect({date, formattedDate, datepicker}) {
			if ( date !== undefined ) {
				$( datepicker.$el ).closest( '.form-group' ).addClass( 'filled' );
			} else {
				$( datepicker.$el ).closest( '.form-group' ).removeClass( 'filled' );
			}
		}
	});

	function headerLine() {
		const line = $('.header-line');
		if (line.length > 0 && line.is(':visible')) {
			$('.wrapper').addClass('with-header-line');
		} else {
			$('.wrapper').removeClass('with-header-line');
		}
	}
	headerLine();

	var minDate = new Date();
	$('.js-date-range').each(function (){
		minDate.setDate(minDate.getDate() + $(this).data('day-duration'));
		new AirDatepicker(this, {
			locale: localeUk,
			minDate: minDate,
			onSelect({date, formattedDate, datepicker}) {
				if ( date !== undefined ) {
					$( datepicker.$el ).closest( '.form-group' ).addClass( 'filled' );
				} else {
					$( datepicker.$el ).closest( '.form-group' ).removeClass( 'filled' );
				}
			}
		});
	})

	var posTime = 'left center';
	function positionTime(){
		if ($(window).outerWidth() < 768) {
			posTime = 'bottom center';
		} else {
			posTime = 'left center';
		}
	}

	positionTime();

	$('.js-time').each(function () {
        new AirDatepicker(this, {
            locale: localeUk,
            timepicker: true,
            onlyTimepicker: true,
            position: posTime,
            onSelect({date, formattedDate, datepicker}) {
                if ( date !== undefined ) {
                    $( datepicker.$el ).closest( '.form-group' ).addClass( 'filled' );
                } else {
                    $( datepicker.$el ).closest( '.form-group' ).removeClass( 'filled' );
                }
            }
        });
    });



	/* - - - - - - - - - - - - - -       parallax mouse       - - - - - - - - - - - - - - - */
	function mouseMoveImage( e, $this, $box = false ) {
		const windowWidth = $box ? $box.innerWidth() : $( window ).width(),
			windowHeigth = $box ? $box.innerHeight() : $( window ).height(),
			halfWindowWidth = windowWidth / 2,
			halfWindowHeigth = windowHeigth / 2,
			dDefault = parseInt( windowWidth * 0.05 ),
			top = $( window ).scrollTop(),
			posLeft = $box ? e.clientX - $box.offset().left : e.clientX,
			posTop = $box ? e.clientY - ( $box.offset().top - top ) : e.clientY;
		let depth = $this.data( 'depth' ),
			dx = 0,
			dy = 0,
			directionX = ( posLeft - halfWindowWidth < 0 ) ? '-' : '',
			directionY = ( posTop - halfWindowHeigth < 0 ) ? '-' : '',
			percentX = 0,
			percentY = 0;
		if ( depth === undefined || depth === '' ) {
			depth = 1;
		} else {
			depth = parseFloat( depth );
		}
		percentX = parseInt( ( Math.abs( posLeft - halfWindowWidth ) ) * 100 / halfWindowWidth ) / 100;
		percentX = ( percentX > 100 ) ? 100 : percentX;
		percentY = parseInt( ( Math.abs( posTop - halfWindowHeigth ) ) * 100 / halfWindowHeigth ) / 100 / 2;
		dx = directionX + parseFloat( ( percentX * dDefault ).toFixed( 2 ) ) * depth;
		dy = directionY + parseFloat( ( percentY * dDefault ).toFixed( 2 ) ) * depth;
		$this.css({
			'transform': 'translate(' + dx + 'px, ' + dy + 'px)'
		});
	}
	if ( $( '.js-parallax' ).length ) {
		$( '.js-parallax' ).each( function () {
			const $this = $( this ),
				$box = $this.data( 'box' ) !== undefined ? $this.parent() : false;
				if ( $box ) {
					$box.on( 'mousemove', function( e ) {
						mouseMoveImage( e, $this, $box );
					});
					$box.on( 'mouseleave', function( e ) {
						$this.css({
							'transform': 'translate(0, 0)',
						});
					});
				} else {
					$( document ).on( 'mousemove', function( e ) {
						mouseMoveImage( e, $this );
					});
					$( document ).on( 'mouseleave', function( e ) {
						$this.css({
							'transform': 'translate(0, 0)',
						});
					});
				}
		});
	}

	/* - - - - - - - - - - - - - -       parallax 3D mouse       - - - - - - - - - - - - - - - */
	function mouseMoveImage3D( e, $this, $box = false ) {
		const windowWidth = $box ? $box.innerWidth() : $( window ).width(),
			windowHeigth = $box ? $box.innerHeight() : $( window ).height(),
			halfWindowWidth = windowWidth / 2,
			halfWindowHeigth = windowHeigth / 2,
			dDefault = 10,
			top = $( window ).scrollTop(),
			posLeft = $box ? e.clientX - $box.offset().left : e.clientX,
			posTop = $box ? e.clientY - ( $box.offset().top - top ) : e.clientY;
		let dx = 0,
			dy = 0,
			directionX = ( posLeft - halfWindowWidth < 0 ) ? '-' : '',
			directionY = ( posTop - halfWindowHeigth < 0 ) ? '-' : '',
			percentX = 0,
			percentY = 0;
		percentX = parseInt( ( Math.abs( posLeft - halfWindowWidth ) ) * 100 / halfWindowWidth ) / 100;
		percentX = ( percentX > 100 ) ? 100 : percentX;
		percentY = parseInt( ( Math.abs( posTop - halfWindowHeigth ) ) * 100 / halfWindowHeigth ) / 100;
		dx = directionX + parseFloat( ( percentX * dDefault ).toFixed( 2 ) );
		dy = directionY + parseFloat( ( percentY * dDefault ).toFixed( 2 ) );
		// console.log(dx, dy)
		$this.css({
			'transform': 'rotateX(' + dy + 'deg) rotateY(' + dx + 'deg)'
		});
		$this.find('[data-offset]').each(function () {
			const offset = $(this).data( 'offset' );
			// console.log(depth)
			dx = directionX + parseFloat( ( percentX * dDefault ).toFixed( 2 ) ) * offset;
			dy = directionY + parseFloat( ( percentY * dDefault ).toFixed( 2 ) ) * offset;
			$(this).css({
				'transform': 'translate3d(' + dx + 'px,' + dy + 'px, 0px)'
			});
		});
	}
	if ( $( '.js-parallax-3d' ).length ) {
		$( '.js-parallax-3d' ).each( function () {
			const $this = $( this ),
				$box = $this.data( 'box' ) !== undefined ? $this.parent() : false;
				if ( $box ) {
					$box.on( 'mousemove', function( e ) {
						mouseMoveImage3D( e, $this, $box );
					});
					$box.on( 'mouseleave', function( e ) {
						$this.css({
							'transform': 'rotate(0, 0)',
						});
					});
				} else {
					$( document ).on( 'mousemove', function( e ) {
						mouseMoveImage3D( e, $this );
					});
					$( document ).on( 'mouseleave', function( e ) {
						$this.css({
							'transform': 'rotate(0, 0)',
						});
					});
				}
		});
	}

	/* - - - - - - - - - - - - - -       show/hide header       - - - - - - - - - - - - - - - */
    let lastScrollTop = 0;
    $( window ).on( 'scroll', function() {
        const top = $( this ).scrollTop();
        if ( top > 0 ) {
            $( '.header' ).addClass( 'fixed' );
        } else {
            $( '.header' ).removeClass( 'fixed' );
        }
        if ( top > lastScrollTop && top > 0 ) {
            if ( !$( '.header' ).hasClass( 'show-menu' ) ) {
                $( '.header' ).addClass( 'hide' );
            }
        } else {
            $( '.header' ).removeClass( 'hide' );
        }
        lastScrollTop = top;
    });

	/* - - - - - - - - - - - - - -       rebuild header       - - - - - - - - - - - - - - - */
	$( '.header' ).addClass( 'loaded' );
	function rebuildHeader() {
		const $topMenu = $( '.top-menu' ).detach(),
			$headerButton = $( '.header-button' ).detach();
		if ( window.matchMedia( '(min-width:768px)' ).matches ) {
			$( '.header-bottom' ).prepend( $headerButton );
			$( '.header-bottom' ).prepend( $topMenu );
		} else {
			$( '.header-top' ).prepend( $topMenu );
			$( '.header-top' ).append( $headerButton );
		}
	}
	if ( $( '.header' ).length ) {
		rebuildHeader();
		$( window ).on( 'resize', function() {
			rebuildHeader();
		});
	}

	/* - - - - - - - - - - - - - -       menu toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-menu-toggle', function() {
		if ( !$( this ).hasClass( 'active' ) ) {
			$( this ).addClass( 'active' );
			$( '.header' ).addClass( 'show-menu' );
		} else {
			$( this ).removeClass( 'active' );
			$( '.header' ).removeClass( 'show-menu' );
		}
	});

	$( document ).on( 'click', '.js-header-submenu', function( e ) {
		e.preventDefault();
		const $this = $( this ),
			$parent = $this.closest( 'li' );
		if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
			if ( !$parent.hasClass( 'show' ) ) {
				$parent.find( 'ul' ).slideDown( 500 );
			} else {
				$parent.find( 'ul' ).slideUp( 500 );
			}
		}
		if ( !$parent.hasClass( 'show' ) ) {
			$parent.addClass( 'show' );
		} else {
			$parent.removeClass( 'show' );
		}
	});
	$( document ).on( 'click', function( e ) {
		if ( $( e.target ).closest( '.header-menu' ).length ) {
			return;
		}
		$( '.header-menu > ul > li' ).removeClass( 'show' );
		if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
			$( '.header-menu > ul > li ul' ).slideUp( 500 );
		}
	});
	$( window ).on( 'resize', function() {
		if ( window.matchMedia( '(min-width: 768px)' ).matches ) {
			$( '.header-menu > ul > li > a, .header-menu > ul > li > span' ).removeClass( 'show' );
			$( '.header-menu > ul > li ul' ).css( 'display', '' );
		}
	});

	/* - - - - - - - - - - - - - -       button hover       - - - - - - - - - - - - - - - */
	$( '.btn:not(.btn-icon):not(.btn-link)' ).each( function () {
		$( this ).append( '<span class="btn-hover"></span>' );
	});
    $( '.btn-big:not(.btn-icon):not(.btn-link)' ).each( function () {
        $( this ).append( '<span class="btn-hover"></span>' );
    });
	$( document ).on( 'mouseenter', '.btn, .btn-big', function( e ) {
		const $this = $( this ),
			btnWidth = Math.floor( $this.innerWidth() ) + 20,
			btnHeight = Math.floor( $this.innerHeight() ),
			$btnHover = $this.find( '.btn-hover' );
		let pointX = e.pageX - $this.offset().left - btnWidth,
			pointY = e.pageY - $this.offset().top - btnWidth;
		$btnHover.css({
			'width': btnWidth * 2 + 'px',
			'height': btnWidth * 2 + 'px',
			'left': pointX + 'px',
			'top': pointY + 'px',
			'transform': 'scale(1)'
		});
	});
	$( document ).on( 'mouseleave', '.btn, .btn-big', function( e ) {
		const $this = $( this ),
			btnWidth = Math.floor( $this.innerWidth() ) + 20,
			$btnHover = $this.find( '.btn-hover' );
		let pointX = e.pageX - $this.offset().left - btnWidth,
			pointY = e.pageY - $this.offset().top - btnWidth;
		$btnHover.css({
			'left': pointX + 'px',
			'top': pointY + 'px',
			'transform': ''
		});
	});

	/* - - - - - - - - - - - - - -       wish toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-wish', function() {
		const $this = $( this );
		if ( !$this.hasClass( 'active' ) ) {
			$this.addClass( 'active' );
		} else {
			$this.removeClass( 'active' );
		}
	});

	/* - - - - - - - - - - - - - -       init catalog slider       - - - - - - - - - - - - - - - */
	function initBenefitsSlider() {
		const benefitsSlider = $( '.js-benefits-slider' );
		if ( window.matchMedia( '(max-width:1279px)').matches ) {
			benefitsSlider.owlCarousel({
				loop: true,
				nav: true,
				dots: false,
				smartSpeed: 600,
				items: 1,
				slideBy: 1,
				autoHeight: true,
				margin: 60,
				navText: [
					'<span class="icon icon-i-arrow-left"></span>',
					'<span class="icon icon-i-arrow-right"></span>'
				]
			})
		} else {
			benefitsSlider.trigger( 'destroy.owl.carousel' );
		}
	}
	initBenefitsSlider();
	$( window ).on( 'resize', function() {
		initBenefitsSlider();
	});

	let lastScrollTopBenefits = 0;
	function fixedBenefits() {
		if ( window.matchMedia( '(min-width:1280px)' ).matches ) {
			const top = $( window ).scrollTop(),
				$benefits = $( '.benefits-box' ),
				count = $benefits.length;
			let isFixed = false;
			let indexStart = 0;
			if ( lastScrollTopBenefits > top ) {
				// console.log( 'top' )
				indexStart = 0;
			} else {
				// console.log( 'down' )
				indexStart = 1;
			}
			$benefits.map(( i, item ) => {
				const $this = $( item ),
					posStart = $this.offset().top - ( $( window ).innerHeight() + $this.innerHeight() ) / 2 + $this.innerHeight(),
					posEnd = posStart + $this.innerHeight() + parseInt( $this.css( 'margin-bottom' ) );
				if ( top > posStart && top < posEnd ) {
					isFixed = true;
					// $this.addClass( 'show' );
					$( '.benefits-box' ).removeClass( 'show' );
					if ( i === count - 1 ) {
						isFixed = false;
						$( '.benefits-box' ).eq(count - 1).addClass( 'show' );
					} else {
						$( '.benefits-box' ).eq(i + indexStart).addClass( 'show' );
					}
				} else {
					// $this.removeClass( 'show' );
					if ( i === 0 ) {
						if ( top < posStart ) {
							$this.addClass( 'show' );
						}
					}
					if ( i === count - 1 ) {
						if ( top > posEnd ) {
							$this.addClass( 'show' );
						}
					}
				}
			});
			if ( isFixed ) {
				$( '.benefits-box' ).addClass( 'fixed' );
			} else {
				$( '.benefits-box' ).removeClass( 'fixed' );
			}
			lastScrollTopBenefits = top;
		} else {
			$( '.benefits-box' ).removeClass( 'fixed' );
		}
	}
	if ( $( '.benefits-box' ).length ) {
		fixedBenefits();
		$( window ).on( 'scroll resize', fixedBenefits	);
	}

	/* - - - - - - - - - - - - - -       init catalog slider       - - - - - - - - - - - - - - - */
	function initCatalogSlider( $catalogSlider, count ) {
		$catalogSlider.owlCarousel({
			loop: ( count > 1 ),
			// loop: false,
			nav: false,
			dots: false,
			smartSpeed: 600,
			items: 1,
			slideBy: 1,
			margin: 8,
			navText: [
				'<span class="icon icon-i-arrow-left"></span>',
				'<span class="icon icon-i-arrow-right"></span>'
			],
			responsive: {
				768: {
					loop: ( count > 2 ),
					nav: true,
					items: 2,
					margin: 20
				},
				992: {
					loop: ( count > 2 ),
					nav: true,
					items: 2,
					margin: 30
				},
				1200: {
					loop: ( count > 3 ),
					nav: true,
					items: 3,
					margin: 30
				}
			}
		});
	}
	$( '.js-catalog-slider' ).each( function() {
		const $this = $( this ),
			count = $this.find( '> *' ).length;
		initCatalogSlider( $this, count );
	});

	/* - - - - - - - - - - - - - -       history region toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-history-region li', function() {
		const $this = $( this ),
			$parent = $this.closest( 'ul' ),
			$box = $this.closest( '.history-area' ),
			$selectRegion = $box.find( '.history-area__list .history-area__select' ),
			$selectRegionTitle = $selectRegion.find( '.history-area__select-title' ),
			$selectCity = $box.find( '.history-area__city .history-area__select' ),
			$selectCityTitle = $selectCity.find( '.history-area__select-title' ),
			$result = $box.find( '.history-area__result .history-area__title' ),
			arrowTpl = '<span class="icon icon-i-arrow-big-left"></span>';
		if ( !$this.hasClass( 'active' ) ) {
			$parent.find( 'li' ).removeClass( 'active' );
			$this.addClass( 'active' );
			$box.removeClass( 'show-map' ).addClass( 'show-city' );
			$result.html( arrowTpl + $this.text() );
			$selectRegion.addClass( 'selected' ).removeClass( 'show' );
			$selectRegionTitle.text( $this.text() );
			$selectCity.removeClass( 'selected' );
			$selectCity.parent().find( 'li' ).removeClass( 'active' );
			$selectCityTitle.text( '' );
			if ( window.matchMedia( '(max-width:991px)' ).matches ) {
				$parent.slideUp( 500 );
			}
		} else {
			$this.removeClass( 'active' );
			$box.removeClass( 'show-city' );
			$selectRegion.removeClass( 'selected' );
			$selectRegionTitle.text( '' );
		}
	});
	$( document ).on( 'click', '.js-history-city li', function() {
		const $this = $( this ),
			$parent = $this.closest( 'ul' ),
			$box = $this.closest( '.history-area' ),
			$selectCity = $box.find( '.history-area__city .history-area__select' ),
			$selectCityTitle = $selectCity.find( '.history-area__select-title' ),
			$result = $box.find( '.history-area__result .history-area__title .icon' );
		if ( !$this.hasClass( 'active' ) ) {
			$parent.find( 'li' ).removeClass( 'active' );
			$this.addClass( 'active' );
			$box.addClass( 'show-map' );
			$selectCity.addClass( 'selected' ).removeClass( 'show' );
			$selectCityTitle.text( $this.text() );
			$result.after( $this.text() + ', ' );
		} else {
			$this.removeClass( 'active' );
			$box.removeClass( 'show-map' );
		}
	});
	$( document ).on( 'click', '.js-history-back', function() {
		const $this = $( this ),
			$box = $this.closest( '.history-area' );
		$box.removeClass( 'show-city show-map' );
		$box.find( '.history-area__list li' ).removeClass( 'active' );
		$this.text( '' );
		$box.find( '.history-area__select' ).removeClass( 'selected' );
	});
	$( document ).on( 'click', '.js-history-area-select', function() {
		const $this = $( this ),
			$parent = $this.parent();
		if ( !$this.hasClass( 'show' ) ) {
			$this.addClass( 'show' );
			$parent.find( 'ul' ).slideDown( 500 );
		} else {
			$this.removeClass( 'show' );
			$parent.find( 'ul' ).slideUp( 500 );
		}
	});
	$( document ).on( 'click', function( e ) {
		if ( $( e.target ).closest( '.history-area__select' ).length ) {
			return;
		}
		$( '.history-area__select' ).removeClass( 'show' );
		if ( window.matchMedia( '(max-width: 991px)' ).matches ) {
			$( '.history-area__select' ).parent().find( 'ul' ).slideUp( 500 );
		}
	});
	$( window ).on( 'resize', function() {
		if ( window.matchMedia( '(min-width: 992px)' ).matches ) {
			$( '.history-area__form ul' ).css( 'display', '' );
		}
	});

	/* - - - - - - - - - - - - - -       tag action       - - - - - - - - - - - - - - - */
	if ( $( '.catalog-sort' ).length ) {
		$( window ).on( 'resize', function() {
			if ( window.matchMedia( '(min-width:992px)' ).matches ) {
				$( '.catalog-sort' ).css( 'display', '' );
				if ( $( '.catalog-sort' ).hasClass( 'fancybox-content' ) ) {
					$.fancybox.close();
					setTimeout( function() {
						$( '.catalog-sort' ).css( 'display', '' );
					}, 500 );
				}
			}
		});
	}
	function setCatalogTagScroll( $this ) {
		if ( window.matchMedia( '(min-width:992px)' ).matches ) {
			const $content = $this.find( '.catalog-sort__content' ),
				$list = $this.find( '.catalog-sort__list' );
			let actionWidth = $this.hasClass( 'scroll' ) ? 0 : 180;
			if ( $content.innerWidth() <= $list.innerWidth() + actionWidth ) {
				$this.addClass( 'scroll' );
			} else {
				$this.removeClass( 'scroll' );
			}
		} else {
			$this.removeClass( 'scroll' );
		}
	}
	if ( $( '.catalog-sort__group' ).length ) {
		$( '.catalog-sort__group' ).each( function () {
			setCatalogTagScroll( $( this ) );
		});
		$( window ).on( 'resize', function() {
			$( '.catalog-sort__group' ).each( function () {
				setCatalogTagScroll( $( this ) );
			});
		});
	}
	$( document ).on( 'click', '.js-catalog-sort-clear' , function( e ) {
		e.preventDefault();
		const $this = $( this ),
			$parent = $this.closest( '.catalog-sort' );
		$parent.find( '.tag [type="checkbox"]' ).prop( 'checked', false );
	});

	/* - - - - - - - - - - - - - -       tag srcoll       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-tag-prev', function( e ) {
		e.preventDefault();
		const $parent = $( this ).closest( '.catalog-sort__group' ),
			$list = $parent.find( '.catalog-sort__list' ),
			posLeft = parseInt( $list.css( 'padding-left' ) );
		let posCurrent = $list.find( '.tag:first-child' ).position().left;
		// if ( posCurrent < posLeft ) {
			posCurrent += 100 - posLeft;
		// }
		$list.stop().animate({ scrollLeft: -1 * posCurrent + 'px' }, 500 );
	});
	$( document ).on( 'click', '.js-tag-next', function( e ) {
		e.preventDefault();
		const $parent = $( this ).closest( '.catalog-sort__group' ),
			$list = $parent.find( '.catalog-sort__list' ),
			posLeft = parseInt( $list.css( 'padding-left' ) );
		let posCurrent = $list.find( '.tag:first-child' ).position().left;
		// if ( posCurrent < posLeft ) {
			posCurrent -= 100 + posLeft;
		// }
		$list.stop().animate({ scrollLeft: -1 * posCurrent + 'px' }, 500 );
	});
	$( document ).on( 'click', '.js-tag-clear', function( e ) {
		e.preventDefault();
		const $parent = $( this ).closest( '.catalog-sort__group' ),
			$list = $parent.find( '.catalog-sort__list' );
		$list.find( '.tag [type="checkbox"]' ).prop( 'checked', false );
		setCatalogTagScroll( $parent );
	});
	// $( document ).on( 'focus', '.tag [type="checkbox"]', function(){
	// 	preventScroll: true
	// });
	$( document ).on( 'change', '.tag [type="checkbox"]', function() {
		const $parent = $( this ).closest( '.catalog-sort__group' );
		// 	$list = $parent.find( '.catalog-sort__list' );
		// let posCurrent = $list.find( '.tag:first-child' ).position().left;
		setCatalogTagScroll( $parent );
	});

	/* - - - - - - - - - - - - - -       description toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-description-more', function( e ) {
		e.preventDefault();
		const $this = $( this ),
			$parent = $this.closest( '.description-box__content' ),
			$text = $parent.find( '.description-box__text' );
		if ( !$this.hasClass( 'active' ) ) {
			$this.addClass( 'active' );
			$this.text( $this.attr( 'data-text-hide' ) );
			$text.find( '> *:nth-child(n+2)' ).slideDown( 500 );
		} else {
			$this.removeClass( 'active' );
			$this.text( $this.attr( 'data-text-show' ) );
			$text.find( '> *:nth-child(n+2)' ).slideUp( 500 );
		}
	});

    /* - - - - - - - - - - - - - -       city toggle       - - - - - - - - - - - - - - - */
    $( document ).on( 'click', '.js-city-more', function( e ) {
        e.preventDefault();
        const $this = $( this ),
            $parent = $this.closest( '.city-toggle' );
        if ( !$parent.hasClass( 'active' ) ) {
            $parent.addClass( 'active' );
            $this.text( $this.attr( 'data-text-hide' ) );
        } else {
            $parent.removeClass( 'active' );
            $this.text( $this.attr( 'data-text-show' ) );
        }
    });

	/* - - - - - - - - - - - - - -       init reviews slider       - - - - - - - - - - - - - - - */
	function initReviewsSlider( $reviewsSlider, count ) {
		$reviewsSlider.owlCarousel({
			loop: ( count > 1 ),
			// loop: false,
			nav: false,
			dots: false,
			smartSpeed: 600,
			items: 1,
			slideBy: 1,
			margin: 8,
			navText: [
				'<span class="icon icon-i-arrow-left"></span>',
				'<span class="icon icon-i-arrow-right"></span>'
			],
			responsive: {
				768: {
					loop: ( count > 2 ),
					nav: true,
					items: 2,
					margin: 20
				},
				992: {
					loop: ( count > 2 ),
					nav: true,
					items: 2,
					margin: 30
				},
				1200: {
					loop: ( count > 3 ),
					nav: true,
					items: 3,
					margin: 30
				}
			}
		});
	}
	$( '.js-reviews-slider' ).each( function() {
		const $this = $( this ),
			count = $this.find( '> *' ).length;
		initReviewsSlider( $this, count );
	});

	/* - - - - - - - - - - - - - -       init video reviews slider       - - - - - - - - - - - - - - - */
	function initVidRevSlider( $videoreviewsSlider, count ) {
		$videoreviewsSlider.children().each( function( index ) {
			$(this).attr( 'data-position', index );
		});

		$videoreviewsSlider.owlCarousel({
			loop: ( count > 1 ),
			// loop: false,
			nav: false,
			dots: false,
			smartSpeed: 600,
			items: 1,
			slideBy: 1,
			margin: 4,
			center: true,
			autoWidth: true,
			responsive: {
				320: {
					loop: ( count > 2 ),
					items: count,
					margin: 4
				},
				576: {
					loop: ( count > 2 ),
					items: count,
					margin: 30
				},
				1200: {
					loop: ( count > 3 ),
					items: count,
					margin: 30
				}
			}
		});

		$(document).on('click', '.owl-item>div', function() {
			$videoreviewsSlider.trigger('to.owl.carousel', $(this).data( 'position' ) );
		});

		$('.js-videoreviews-nav.owl-next').click(function() {
			$videoreviewsSlider.trigger('next.owl.carousel');
		})
		$('.js-videoreviews-nav.owl-prev').click(function() {
			$videoreviewsSlider.trigger('prev.owl.carousel');
		})
	}
	$( '.js-videoreviews-slider' ).each( function() {
		const $this = $( this ),
			count = $this.find( '> *' ).length;
		initVidRevSlider( $this, count );
	});

	/* - - - - - - - - - - - - - -       init count       - - - - - - - - - - - - - - - */
	$( '.count' ).each( function () {
		var $this = $( this ),
			$field = $this.find( '.count-value' ),
			count = 0,
			$plus = $this.find( '.count-inc' ),
			$minus = $this.find( '.count-dec' ),
			min = parseInt( $field.attr( 'data-min' ) ),
			max = parseInt( $field.attr( 'data-max' ) ),
			postfix = $field.attr( 'data-postfix' );
		postfix = postfix !== '' && postfix !== undefined ? ' ' + postfix : '';
		if ( parseInt( $field.val() ) === min ) {
			$minus.addClass( 'disabled' );
		} else if ( parseInt( $field.val() ) === max ) {
			$plus.addClass( 'disabled' );
		} else {
			$plus.removeClass( 'disabled' );
			$minus.removeClass( 'disabled' );
		}
		$plus.on( 'click', function() {
			$minus.removeClass( 'disabled' );
			count = parseInt( $field.val() );
			if ( count < max - 1 ) {
				count++;
			} else {
				$plus.addClass( 'disabled' );
				count = max;
			}
			$field.val( count + postfix );
		});
		$minus.on( 'click', function() {
			$plus.removeClass( 'disabled' );
			count = parseInt( $field.val() );
			if ( count > min + 1 ) {
				count--;
			} else {
				$minus.addClass( 'disabled' );
				count = min;
			}
			$field.val( count + postfix );
		});
		$field.on( 'input', function() {
			$plus.removeClass( 'disabled' );
			$minus.removeClass( 'disabled' );
			count = $field.val();
			count = ( count === '' ) ? count : parseInt( count );
			count = ( isNaN( count ) ) ? '' : count;
			if ( count < min + 1 ) {
				$minus.addClass( 'disabled' );
				if ( count === '' ) {
					count = '';
				} else {
					count = min;
				}
			} else if ( count > max - 1 ) {
				$plus.addClass( 'disabled' );
				count = max;
			}
			$field.val( count );
		});
		$field.on( 'focus', function() {
			count = parseInt( $field.val() );
			$field.val( count );
		});
		$field.on( 'blur', function() {
			count = $field.val();
			if ( count === '' ) {
				count = min;
			}
			$field.val( parseInt( count ) + postfix );
		});
	});

	/* - - - - - - - - - - - - - -      stiky sidebar       - - - - - - - - - - - - - - - */
	function stikySidebar() {
        if($('.js-sidebar').is('*')) {
            let sidebar = new StickySidebar('.js-sidebar', {
                containerSelector: '.js-sidebar-container',
                innerWrapperSelector: '.js-sidebar-inner',
                topSpacing: 200
            });

			if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
                sidebar.destroy();
            } else {
                sidebar.updateSticky()
            }

			$( window ).on( 'resize', function(){
                if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
                    sidebar.destroy();
                } else {
                    sidebar.updateSticky()
                }
            });

            $( window ).on( 'scroll', function() {
                if ( window.matchMedia( '(min-width:1200px)' ).matches ) {
                    sidebar.updateSticky()
                }
            })


        }
    }
    stikySidebar();

	/* - - - - - - - - - - - - - -       product other toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-product-other-toggle', function() {
		const $parent = $( this ).closest( '.product-box__other' );
		if ( !$parent.hasClass( 'show' ) ) {
			$parent.addClass( 'show' );
			$parent.find( '.product-box__other-toggle' ).slideDown( 500 );
		} else {
			$parent.removeClass( 'show' );
			$parent.find( '.product-box__other-toggle' ).slideUp( 500 );
		}
		setTimeout( function() {
			rellax.refresh();
		}, 500)
	});

	/* - - - - - - - - - - - - - -       init product gallery slider       - - - - - - - - - - - - - - - */
	const $productGalleryBig = $( '.js-product-gallery-big' );
	$productGalleryBig.owlCarousel({
		animateOut: 'fadeOut',
		loop: false,
		nav: false,
		dots: false,
		smartSpeed: 600,
		items: 1,
		slideBy: 1,
		mouseDrag: false,
		touchDrag: false
	});

	const $productGallerySmall = $( '.js-product-gallery-small' );
	let productGallerySmallCount = 0;
	if ( $productGallerySmall.length ) {
		productGallerySmallCount = $productGallerySmall.children().length;
	}
	$productGallerySmall.children().each( function ( index ) {
		$( this ).attr( 'data-position', index );
	});
	$productGallerySmall.on( 'initialized.owl.carousel', function() {
		const $firstSlide = $productGallerySmall.find('.product-box__gallery-box[data-position="0"]').closest( '.owl-item' );
		if ( $firstSlide.hasClass( 'active' ) ) {
			$firstSlide.addClass( 'current' );
		}
	})
	$productGallerySmall.owlCarousel({
		loop: ( productGallerySmallCount > 3 ),
		nav: true,
		dots: false,
		smartSpeed: 600,
		items: 3,
		slideBy: 1,
		margin: 8,
		navText: [
			'<span class="icon icon-i-arrow-left"></span>',
			'<span class="icon icon-i-arrow-right"></span>'
		]
	}).on( 'change.owl.carousel', function( $slider ) {
		let activeSlideIndex = $slider.property.value - $slider.isTrigger;
		if ( isNaN( activeSlideIndex ) ) {
			activeSlideIndex = $slider.item.index - $slider.isTrigger;
		}
		if ( activeSlideIndex < 0 ) {
			activeSlideIndex = $slider.item.count - 1;
		}
		if ( activeSlideIndex >= $slider.item.count ) {
			activeSlideIndex = 0;
		}
		$productGallerySmall.find( '.owl-item' ).removeClass( 'current' );
		$productGallerySmall.find( '.product-box__gallery-box[data-position=' + activeSlideIndex + ']' ).closest( '.owl-item' ).addClass( 'current' );
		$productGalleryBig.trigger( 'to.owl.carousel', [ activeSlideIndex, 600 ] );
	});
	$( document ).on( 'click', '.js-product-gallery-small .owl-item > div', function() {
		$productGallerySmall.trigger( 'to.owl.carousel', [ $( this ).data( 'position' ), 600 ] );
		$productGallerySmall.find( '.owl-item' ).removeClass( 'current' );
		$( '.product-box__gallery-box[data-position=' + $( this ).data( 'position' ) + ']' ).closest( '.owl-item' ).addClass( 'current' );
		$productGalleryBig.trigger( 'to.owl.carousel', [ $( this ).data( 'position' ), 600 ] );
	});

	/* - - - - - - - - - - - - - -       basket tabs       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.basket-box__tabs-title li', function( e ) {
		e.preventDefault();
		const $this = $( this ),
			$parent = $this.closest( '.basket-box__tabs' );
		if ( !$this.hasClass( 'active' ) ) {
			$parent.find( '.basket-box__tabs-title li' ).removeClass( 'active' );
			$this.addClass( 'active' );
			$parent.find( '.basket-box__tabs-box' ).removeClass( 'show' );
			$parent.find( '.basket-box__tabs-box[data-tab="' + $this.attr( 'data-tab' ) + '"]' ).addClass( 'show' );
		}
	});

	/* - - - - - - - - - - - - - -       init sticky basket       - - - - - - - - - - - - - - - */
	if ( $( '.js-sticky' ).length ) {
		const $this = $( '.js-sticky' ),
			$receipt = $this.closest( '.basket-box__receipt' ),
			$parent = $this.closest( '.basket-box' );
		const posTop = parseInt( $parent.css( 'padding-top' ) );
		let posBottom = $( document ).innerHeight() - $receipt.offset().top - $receipt.innerHeight() + posTop / 2;

		if ( !$this.closest( '.sticky-wrapper' ).length ) {
			posBottom += posTop;
		}
		const $sticky = $this.sticky({
			topSpacing: posTop,
			bottomSpacing: posBottom
		});
		$( window ).on( 'resize', function() {
			if ( window.matchMedia( '(max-width: 991px)' ).matches ) {
				$sticky.unstick();
			} else {
				posBottom = $( document ).innerHeight() - $receipt.offset().top - $receipt.innerHeight();
				$sticky.sticky({
					topSpacing: posTop,
					bottomSpacing: posBottom
				});
			}
		});
	}

	/* - - - - - - - - - - - - - -       init gallery slider       - - - - - - - - - - - - - - - */
	function initGallerySlider( $gallerySlider, count ) {
		$gallerySlider.owlCarousel({
			loop: ( count > 1 ),
			// loop: false,
			nav: false,
			dots: false,
			smartSpeed: 600,
			items: 1,
			slideBy: 1,
			margin: 8,
			navText: [
				'<span class="icon icon-i-arrow-left"></span>',
				'<span class="icon icon-i-arrow-right"></span>'
			],
			responsive: {
				320: {
					nav: true,
				},
				768: {
					loop: ( count > 2 ),
					nav: true,
					items: 2,
					margin: 20
				},
				992: {
					loop: ( count > 2 ),
					nav: true,
					items: 2,
					margin: 30
				},
				1200: {
					loop: ( count > 3 ),
					nav: true,
					items: 3,
					margin: 30
				}
			}
		});
	}
	$( '.js-gallery-slider' ).each( function() {
		const $this = $( this ),
			count = $this.find( '> *' ).length;
		initGallerySlider( $this, count );
	});

	/* - - - - - - - - - - - - - -       design form toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-design', function( e ) {
		e.preventDefault();
		const $this = $( this ),
			$designForm = $( '.design-form' );
		if ( !$this.hasClass( 'active' ) ) {
			$this.addClass( 'active' );
			$designForm.slideDown( 500 );
		} else {
			$this.removeClass( 'active' );
			$designForm.slideUp( 500 );
		}
	});

	function showDesignImg() {
		const top = $( window ).scrollTop(),
			windowHeight = $( window ).innerHeight(),
			stepWindow = windowHeight / 4,
			$designImg = $( '.design-img' ),
			$designTitle = $( '.design-title' );
		let isShow = $designImg.hasClass( 'show') ? true : false;
		if ( !isShow ) {
			let posStart = 0;
			if ( $designTitle.length && $designTitle.hasClass( 'js-title' ) ) {
				posStart = $designTitle.offset().top - windowHeight + $designTitle.innerHeight();
			} else {
				posStart = $designImg.offset().top - windowHeight;
			}
			if ( top > posStart ) {
				isShow = true;
			}
			if ( isShow ) {
				$designImg.addClass( 'show' );
			}
		}
	}
	if ( $( '.design-img' ).length ) {
		// showDesignImg();
		// $( window ).on( 'scroll', showDesignImg );
	}

	/* - - - - - - - - - - - - - -       input file       - - - - - - - - - - - - - - - */
	function showFileError( $this, error ) {
		$this.addClass( 'has-error' ).removeClass( 'filled' );
		// $this.find( '.file-box__field' ).removeClass( 'hidden' );
		$this.find( '.js-file [type="file"]' ).val( '' );
		$this.find( '.help-block' ).text( error );
	}
	$( document ).on( 'change', '.js-file [type="file"]', function( e ) {
		const $this = $( this );
		const $parent = $this.closest( '.form-group' );
		const list = $this[ 0 ].files;
		const errorType = $this.attr( 'data-error-type' ) ? $this.attr( 'data-error-type' ) : 'Error';
		const errorSize = $this.attr( 'data-error-size' ) ? $this.attr( 'data-error-size' ) : 'Error';
		$parent.removeClass( 'has-error' );
		$parent.find( '.help-block' ).text( '' );
		$this.closest( '.file-box' ).find( '.file-box__list-box' ).remove();
		$this.closest( '.file-box' ).find( '.file-box__delete' ).remove();

		// if ( $this.attr( 'multiple' ) === undefined ) {
		// 	$this.closest( '.file-box' ).find( '.file-box__field' ).addClass( 'hidden' );
		// }
		for ( let i = 0; i < list.length; i++ ) {
			const name = list[ i ].name;
			let size = 5000 ; // size of kb
			let fileBoxTpl = '';

			// validate type file
			const typeFileArr = $this.attr( 'accept' ).split(',');
			if ( !typeFileArr.includes( '.' + name.slice( -5 ).split( '.' )[ 1 ].toLowerCase() ) ) {
				showFileError( $parent, errorType );
				return false;
			}

			// validate size file
			if ( $this.attr( 'data-size' ) && $this.attr( 'data-size' ) !== '' ) {
				size = parseInt( $this.attr( 'data-size' ) );
			}
			if ( size < list[ i ].size / 1000 ) {
				showFileError( $parent, errorSize );
				return false;
			}

			fileBoxTpl =
				'<div class="file-box__list-box">' +
					'<div class="file-box__list-box-name">' +
						name +
					'</div>' +
				'</div>';
			fileDeleteTpl =
				'<div class="file-box__delete js-file-delete">' +
					'<span class="icon icon-i-close"></span>' +
				'</div>';
			$parent.find( '.file-box__list' ).append( fileBoxTpl );
			$this.closest( '.file-box' ).append( fileDeleteTpl );
		}
	});
	$( document ).on( 'click', '.js-file-delete', function() {
		const $this = $( this ),
			$parent = $this.closest( '.form-group' );
		// $( this ).closest( '.file-box' ).find( '.file-box__field' ).removeClass( 'hidden' );
		$this.remove();
		$parent.removeClass( 'filled' );
		$parent.find( '.file-box__list-box' ).remove();
		$parent.find( '[type="file"]' ).val( '' );
	});

	/* - - - - - - - - - - - - - -       catalog tabs       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.catalog-tabs__title li', function( e ) {
		e.preventDefault();
		const $this = $( this ),
			$list = $this.closest( '.catalog-tabs__title' ),
			posLeft = parseInt( $list.css( 'padding-left' ) );

		let $parent = $this.closest( '.catalog-tabs' );
		if ($this.hasClass('account-tab')) {
			$parent = $this.closest( '.account-box' );
		}
		if ( !$this.hasClass( 'active' ) ) {
			$parent.find( '.catalog-tabs__title li' ).removeClass( 'active' );
			$this.addClass( 'active' );
			$parent.find( '.catalog-tabs__box' ).removeClass( 'show' );
			$parent.find( '.catalog-tabs__box[data-tab="' + $this.attr( 'data-tab' ) + '"]' ).addClass( 'show' );
			const $catalogTabBox = $parent.find( '.catalog-tabs__box[data-tab="' + $this.attr( 'data-tab' ) + '"]' );
			if ( $catalogTabBox.find( '.catalog-sort__group' ).length ) {
				$catalogTabBox.find( '.catalog-sort__group' ).each( function () {
					setCatalogTagScroll( $( this ) );
				});
			};
		}


		let posCurrent = $list.find( 'li:first-child' ).position().left;
		posCurrent = posCurrent + $(window).innerWidth()/2 - $this.innerWidth()/2 - $this.position().left - posLeft;
		$list.stop().animate({ scrollLeft: -1 * posCurrent + 'px' }, 500 );
	});

	/* - - - - - - - - - - - - - -       init catalog slider       - - - - - - - - - - - - - - - */
	function initAssortmentSlider( $assortmentSlider, count ) {
		$assortmentSlider.owlCarousel({
			loop: ( count > 1 ),
			// loop: false,
			nav: false,
			dots: false,
			smartSpeed: 600,
			items: 1,
			slideBy: 1,
			margin: 16,
			navText: [
				'<span class="icon icon-i-arrow-left"></span>',
				'<span class="icon icon-i-arrow-right"></span>'
			],
			responsive: {
				320: {
					nav: true,
				},
				768: {
					loop: ( count > 2 ),
					nav: true,
					items: 2,
					margin: 30
				},
				992: {
					loop: ( count > 2 ),
					nav: true,
					items: 3,
					margin: 30
				},
				1200: {
					loop: ( count > 4 ),
					nav: true,
					items: 4,
					margin: 30
				}
			}
		});
	}
	$( '.js-assortment-slider' ).each( function() {
		const $this = $( this ),
			count = $this.find( '> *' ).length;
			initAssortmentSlider( $this, count );
	});

	/* - - - - - - - - - - - - - -       title animation       - - - - - - - - - - - - - - - */
	function divideTitle( $this ) {
        const mess = $this.html().trim().replace( /<br>/g, ' <br> ' ).replace( /\s+/g, ' ' ),
			messArr = mess.split( ' ' ),
			delay = $this.data( 'delay' ) && $this.data( 'delay' ) !== '' ? parseInt( $this.data( 'delay' ) ) / 1000 : 0,
			count = mess.replace( /<br>/g, '' ).replace( /\s/g, '' ).length,
			// duration = $this.data( 'duration' ) && $this.data( 'duration' ) !== '' ? parseInt( $this.data( 'duration' ) ) / 1000 : 0.5, // seconds
			duration = Math.ceil( count / 30 ) / 2,
			stepCount = parseFloat( ( duration / count ).toFixed( 3 ) ),
			stepDuration = 0.5;
        let messTpl = '',
			stepDelay = delay;
		messArr.map( ( world, i ) => {
			let spaceTpl = '',
				worldTpl = '';
			if ( i < messArr.length - 1 ) {
				spaceTpl = ' ';
			}
			if ( world === '<br>' ) {
				messTpl += '<br>' + spaceTpl;
			} else {
				for ( let i = 0; i < world.length; i++ ) {
					worldTpl += '<span style="transition-delay: ' +
						stepDelay +
					's; transition-duration: ' +
						stepDuration +
					's;">' + world[i] + '</span>';
					stepDelay = parseFloat( ( stepDelay + stepCount ).toFixed( 3 ) );
				}
				messTpl += '<div>' + worldTpl + '</div>' + spaceTpl;
			}
		});
        $this.html( messTpl ).css({
			'transition-delay': delay + 's',
			'transition-duration': duration + 's'
		});
		// $this.find( 'span' ).each( function() {
		// 	const currentHeight = parseFloat( $( this ).innerHeight().toFixed( 2 ) ) * 0.2;
		// 	$( this ).css( 'transform', 'translate(0, ' + currentHeight + 'px)' );
		// })
    }
    function fillTitle( $this ) {
        const windowHeight = $( window ).innerHeight(),
            stepWindow = windowHeight / 4,
			top = $( window ).scrollTop(),
			posStart = $this.offset().top - windowHeight + stepWindow;
        if ( top > posStart ) {
            $this.addClass( 'show' );
        }
    }
    if ( $( '.js-title' ).length ) {
        $( '.js-title' ).each( function() {
            const $this = $( this );
            divideTitle( $this );
            fillTitle( $this );
            $( window ).on( 'scroll', function() {
                fillTitle( $this );
            });
        });
    }

	function fixedTitle( $this ) {
        const windowHeight = $( window ).innerHeight(),
            stepWindow = windowHeight / 2,
			top = $( window ).scrollTop(),
			$parent = $this.parent(),
			$container = $this.closest( '.history-box' ).length ? $this.closest( '.history-box' ) : $this.closest( '.container' ),
			fontOffset = ( $this.find( '> *:nth-child(1)' ).innerHeight() - ( parseInt( $this.css( 'font-size' ) ) / 2 + $this.find( '> *:nth-child(1)' ).innerHeight() * 0.1 ) ) / 2,
			posStart = $parent.offset().top - stepWindow + $parent.innerHeight() / 2,
			posEnd = $container.offset().top + $container.innerHeight() - stepWindow - $parent.innerHeight() / 2 + fontOffset;
		let posFixed = 0;
        if ( top > posStart && top < posEnd ) {
			posFixed = top - posStart;
			$this.css( 'transition', 'transform 0.15s linear' );
			$this.css( 'transform', 'translateY(' + posFixed + 'px)' );
        } else if ( top > posEnd ) {
			posFixed = $container.offset().top - $parent.offset().top + $container.innerHeight() - $parent.innerHeight() + fontOffset;
			$this.css( 'transform', 'translateY(' + posFixed + 'px)' );
		} else {
			$this.css( 'transform', '' );
		}
    }
	if ( $( '.js-title-fixed' ).length ) {
		$( '.js-title-fixed' ).each( function() {
            const $this = $( this );
            fixedTitle( $this );
            $( window ).on( 'scroll', function() {
                fixedTitle( $this );
            });
        });
	}

	/* - - - - - - - - - - - - - -       object lazy load       - - - - - - - - - - - - - - - */
	function objectLazyLoad() {
		const top = $( window ).scrollTop();
		const d = new Date();
		$( 'object[data-src]' ).each( function() {
			const $this = $( this );
			const imgSrc = $this.attr( 'data-src' );
			if ( imgSrc && imgSrc !== '' ) {
				if ( top > $this.offset().top - $( window ).innerHeight() ) {
					$this.removeAttr( 'data-src' ).attr( 'data', imgSrc + '?v=' + d.getTime() )
				}
			}
		});
	}
	objectLazyLoad();
	$( window ).on( 'scroll', function() {
		objectLazyLoad();
	});

	/* - - - - - - - - - - - - - -       faq       - - - - - - - - - - - - - - - */

	const faq = $('.js-faq');
	if (faq) {
		const btn = faq.find('.return-faq__title');
		faq.find('.return-faq__item').each(function(){
			if ($(this).hasClass('active')) {
				$(this).find('.return-faq__text').slideDown();
			}
		});
		btn.on('click',function(){
			const item = $(this).parents('.return-faq__item');
			item.toggleClass('active');
			item.find('.return-faq__text').slideToggle();
		});
	}

    /* - - - - - - - - - - - - - -       product faq       - - - - - - - - - - - - - - - */

    const prodFaq = $('.js-prodfaq');
    if (prodFaq) {
        const btnFAQ = prodFaq.find('.prodfaq-faq__title');
        prodFaq.find('.prodfaq-faq__item').each(function(){
            if ($(this).hasClass('active')) {
                $(this).find('.prodfaq-faq__text').slideDown();
            }
        });
        btnFAQ.on('click',function(){
            const item = $(this).parents('.prodfaq-faq__item');
            item.toggleClass('active');
            item.find('.prodfaq-faq__text').slideToggle();
        });
    }

    /* - - - - - - - - - - - - - -       shop address map show       - - - - - - - - - - - - - - - */

	const mapItem = $('.shop-main__info .shop-address__item');
	if (mapItem) {
		const mapBox = $('.shop-main__map__wrapper');
		mapItem.on('click',function(){
			mapItem.removeClass('active');
			$(this).addClass('active');
			mapBox.addClass('active');
		});

		$(window).resize(function (){
			if ($(window).innerHeight() > 1199) {
				mapItem.removeClass('active');
				mapBox.removeClass('active');
			}
		});
	}

	/* - - - - - - - - - - - - - -       modal city toggle       - - - - - - - - - - - - - - - */

	$( document ).on( 'click', '.js-city', function() {
		const $this = $( this );
			// $parent = $this.closest( '.header-city' );
		if ( !$this.hasClass( 'show' ) ) {
			$this.addClass( 'show' );
		} else {
			$this.removeClass( 'show' );
		}
	});
	$( document ).on( 'click', function( e ) {
		var missClick = $(".js-city");
		if (!missClick.is(e.target) && missClick.has(e.target).length === 0) {
			if ($('.cityInput').hasClass('show')) {
				$( '.cityInput__modal' ).css( 'display', '' );
				$( '.cityInput' ).removeClass( 'show' );
			}
		}
		if ( $( e.target ).length ) {
			return;
		}
	});

	$( window ).on( 'resize', function() {
		$( '.cityInput' ).removeClass( 'show' );
		$( '.cityInput__modal' ).css( 'display', '' );
	});

	/* - - - - - - - - - - - - - -       modal city search       - - - - - - - - - - - - - - - */
	$( document ).on( 'input', 'body .js-search-city', function() {
		const $this = $( this ),
			$list = $( '[data-search="' + $this.attr( 'data-search' ) + '"]' ).not( $this ),
			$empty = $list.find( '.search-empty' ),
			msg = $this.val().toLowerCase();
		let isEmpty = true;
		// if ( msg.length > 2 ) {
		$list.find( 'li' ).each( (i, item) => {
			if ( ~$( item ).text().toLowerCase().indexOf( msg ) ) {
				$( item ).removeClass( 'hide' );
				isEmpty = false;
			} else {
				$( item ).addClass( 'hide' );
			}
		});
		if ( isEmpty ) {
			$empty.addClass( 'show' );
		} else {
			$empty.removeClass( 'show' );
		}
		// }
	});

	const cityInput = $('.js-search-city');

	$('.cityInput__modal-list').find('li').on('click',function(){
		cityInput.val($(this).text()).closest('.cityInput').addClass('filled');
	});

	/* - - - - - - - - - - - - - -       header city close       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-city-close', function( e ) {
		e.preventDefault();
		const $parent = $( this ).closest('.cityInput');
		$parent.removeClass('show filled');
		$parent.find('.header-city__modal').removeClass('show');
		$parent.find('li').removeClass('.hide');
		cityInput.val('');
	});

	/* - - - - - - - - - - - - - -       add to cart modal       - - - - - - - - - - - - - - - */

	// function addIDtoCart(){
	// 	const btn = $('.catalog-box__button a');
	// 	btn.fancybox({
	// 		src : '#modal-addcart',
	// 		closeExisting: true,
	// 		animationEffect: 'fade',
	// 		touch: false,
	// 		buttons: [
	// 			"slideShow",
	// 			"close"
	// 		],
	// 		smallBtn: true,
	// 		btnTpl: {
	// 			smallBtn:
	// 				'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
	// 				'<span class="icon icon-i-close"></span>' +
	// 				"</button>"
	// 		},
	// 		afterShow: function(instance, current) {
	// 			basketPrice();
	// 			current.$slide.find( '.js-select' ).select2({
	// 				language: 'uk',
	// 				width: '100%',
	// 				minimumResultsForSearch: -1,
	// 				dropdownParent: current.$content
	// 			});
	// 		}
	// 	});
	// }
	//
	// addIDtoCart();

	function objectLazyLoad() {
		const top = $( window ).scrollTop();
		const d = new Date();
		$( 'object[data-src]' ).each( function() {
			const $this = $( this );
			const imgSrc = $this.attr( 'data-src' );
			if ( imgSrc && imgSrc !== '' ) {
				if ( top > $this.offset().top - $( window ).innerHeight() ) {
					$this.removeAttr( 'data-src' ).attr( 'data', imgSrc + '?v=' + d.getTime() )
				}
			}
		});
	}
	objectLazyLoad();
	$( window ).on( 'scroll', function() {
		objectLazyLoad();
	});

	if ( $( '.pagination' ).length ) {
		$( '.pagination li .active' ).closest( 'li' ).css( 'display', 'block' );
	}

	function deliverySpeed(){
		var elem = $('#deliveryspeed');

		if (elem.is(':checked')) {
			$('.form-group-datetime').attr('disabled','disabled');
		} else {
			$('.form-group-datetime').removeAttr('disabled');
		}

		elem.change(function () {
			if ($(this).is(':checked')) {
				$('.form-group-datetime').attr('disabled','disabled');
			} else {
				$('.form-group-datetime').removeAttr('disabled');
			}
		});
	}

	deliverySpeed();

	function mapRoute() {
        const item = $('.shop-address__item');
        if (item.length > 0) {
            item.each(function () {
                let geo1 = $.trim($(this).attr('data-geo1'));
                let geo2 = $.trim($(this).attr('data-geo2'));
                if (typeof geo1 !== typeof undefined && geo1 !== false) {
                    $(this).find('.shop-address__link').attr('href','https://maps.google.com?saddr=Current+Location&daddr='+geo1+','+geo2);
                }
            });
        }
    }

    mapRoute();

    function mapRoutePopup() {
        const item = $('.place__route');
        if (item.length > 0) {
            item.each(function () {
                let geo1 = $.trim($(this).attr('data-geo1'));
                let geo2 = $.trim($(this).attr('data-geo2'));
                if (typeof geo1 !== typeof undefined && geo1 !== false) {
                    $(this).attr('href','https://maps.google.com?saddr=Current+Location&daddr='+geo1+','+geo2);
                }
            });
        }
    }

    mapRoutePopup();

	function mapanchor() {
        const btn = $('.shop-address__btn');
        btn.click(function () {
            if ($(window).outerWidth() < 1200) {
                var destination = $('.shop-main__map').offset().top - 25;
                $("html:not(:animated),body:not(:animated)").animate({scrollTop: destination}, 1200);
            }
        });
    }

    mapanchor();

	/* - - - - - - -        rating       - - - - - - - - */
	$( document ).on( 'change', '.js-rating [type="checkbox"]', function() {
		const $parent = $( this ).closest( '.rating' ),
			index = $( this ).closest( '.rating-box' ).index();
		$parent.find( '[type="checkbox"]' ).prop( 'checked', false );
		for ( let i = 5; i >= index; i-- ) {
			$parent.find( '.rating-box' ).eq( i ).find( '[type="checkbox"]' ).prop( 'checked', true );
		}
	});

    /* - - - - - - -        work popup       - - - - - - - - */

	function workPOP() {
        const pop = $('.js-popupwork');
        const closePOP = $('.js-popupwork-close');
        setTimeout(function () {
            pop.addClass('active');
        },800);
        closePOP.click(function () {
            pop.removeClass('active');
            setTimeout(function () {
                pop.remove();
            },800);
        });
    }

    workPOP();
});
